import { map } from 'lodash'

let handlers = {
  show: {
    text: '查看',
    async handler (obj, callback) {
      let url = ''
      if (callback.type == 3) {
        url = '/cpu-supplymgr-fe/tplcertificationedit/index.zh_CN.html?' +
          'editable=false' +
          '&type=' + callback.type +
          '&id=' + obj.row.value.id
      } else {
        url = '/cpu-supplymgr-fe/tplevaluateedit/index.zh_CN.html?' +
          'editable=false' +
          '&type=' + callback.type +
          '&id=' + obj.row.value.id
      }
      window.open(url)
    }
  }
}
export default function createOptItem (callback) {
  return map(handlers, function (handlerObj, key) {
    // 这里可以统一在handlers里定义
    handlerObj.hidden = function (obj) {
      return false
    }
    handlerObj.callback = callback
    return handlerObj
  })
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/tplCertificationEvaluateHis/opt.js